import CreditCardsApi from '@/api/credit-cards.api'

const state = {
  chargeReceipts: [],
  allCharges: [],
  allChargesTotalCount: 0
}

const actions = {
  async getChargeReceipts({ commit }, buyerId) {
    const response = await CreditCardsApi.getChargeReceipts(buyerId)
    commit('SET_CHARGE_RECEIPTS', response.data || [])
  },

  async getAllCharges({ commit }, { filter, skip, limit }) {
    const response = await CreditCardsApi.getAllCharges({ filter, skip, limit })
    const data = response.data
    commit('SET_ALL_CHARGES', Array.isArray(data) ? data : [])
    return data
  },

  async getAllChargesTotal({ commit }, filter) {
    const response = await CreditCardsApi.getAllChargesTotal(filter)
    const total = response.data || 0
    commit('SET_ALL_CHARGES_TOTAL_COUNT', total)
    return total
  }
}

const mutations = {
  SET_CHARGE_RECEIPTS(state, receipts) {
    state.chargeReceipts = receipts
  },

  SET_ALL_CHARGES(state, charges) {
    state.allCharges = charges
  },

  SET_ALL_CHARGES_TOTAL_COUNT(state, count) {
    state.allChargesTotalCount = count
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
